import { UtilsService } from '@shared/services/utils/utils.service';
import { ViajerosInterfaceReq } from 'src/app/core/models/cotizar-req.model';
import { ViajerosInterface } from 'src/app/core/models/cotizar.model';
import { COVERAGE_TYPES, DURATION_INPUTS, Numbers, TRAVELERS_TYPE } from 'src/app/utils/constants';

export default class FormsStepsUtils {
  utilsSrv: UtilsService;
  /**
   * constructor
   * @param utilsSrv utilsSrv
   */
  constructor(utilsSrv: any) {
    this.utilsSrv = utilsSrv;
  }

  /**
   * setTravelersTypeValue
   * @param numberOfInsuredsOlder numberOfInsuredsOlder
   * @param numberOfInsuredsRisk numberOfInsuredsRisk
   * @param numberOfInsureds numberOfInsureds
   * @param args args
   * @returns returns
   */
  setTravelersTypeValue(numberOfInsuredsOlder: any, numberOfInsuredsRisk: any,
                        numberOfInsureds: any, args: any): Record<string, unknown>[] {
    const { viajerosNormales, viajerosPracticasDeRiesgo, viajerosMayor70Años }: any =
      this.setTravelersType(args);
    let viajerosType: Record<string, unknown>[] = [viajerosNormales];

    if (numberOfInsuredsRisk > 0 && ((numberOfInsuredsRisk === numberOfInsureds.id) ||
      ((numberOfInsuredsOlder + numberOfInsuredsRisk) === numberOfInsureds.id))) {
      viajerosType = [viajerosPracticasDeRiesgo];
    } else {
      if (numberOfInsuredsRisk > 0) {
        viajerosType.push(viajerosPracticasDeRiesgo);
      }
    }

    if (numberOfInsuredsOlder > 0 && numberOfInsuredsOlder === numberOfInsureds.id) {
      viajerosType = [viajerosMayor70Años];
    } else {
      if (numberOfInsuredsOlder > 0) {
        viajerosType.push(viajerosMayor70Años);
      }
    }

    return viajerosType;
  }

  /**
   * setTravelersType
   * @param args args
   * @returns returns
   */
  setTravelersType(args: any): {
    viajerosNormales: ViajerosInterfaceReq;
    viajerosPracticasDeRiesgo: ViajerosInterfaceReq;
    viajerosMayor70Años: ViajerosInterfaceReq;
  } {
    const { numViajerosNormales,
      numberOfInsuredsRisk, numberOfInsuredsOlder }: any = args;

    const viajerosNormales: ViajerosInterfaceReq = this.initTravelers(args, numViajerosNormales, 0);
    const viajerosPracticasDeRiesgo: ViajerosInterfaceReq = this.initTravelers(args, numberOfInsuredsRisk, 1);
    const viajerosMayor70Años: ViajerosInterfaceReq = this.initTravelers(args, numberOfInsuredsOlder, Numbers.number24);

    return { viajerosNormales, viajerosPracticasDeRiesgo, viajerosMayor70Años };
  }

  /**
   * initTravelers
   * @param args args
   * @param numTravelers numTravelers
   * @param id id
   * @returns returns
   */
  initTravelers(args: any, numTravelers: any, id: any): ViajerosInterfaceReq {
    const { formDataValue, auxDestiny, auxExpatriado, auxDays }: any = args;
    const viajerosBase: ViajerosInterfaceReq = {
      idPresupuesto: 0,
      ambitoOrigen: formDataValue.countryOriginEnvironment,
      ambitoDestino: auxDestiny || auxDestiny,
      expatriado: auxExpatriado,
      numDias: auxDays
    };
    const particularData: any = {numViajeros: numTravelers, idSobrePrima: id };
    return { ...viajerosBase, ...particularData };
  }

  /**
   * prepareTraveleres
   * @param firstOptBase firstOptBase
   * @param formDataValue formDataValue
   * @returns returns
   */
  prepareTraveleres(firstOptBase: any, formDataValue: any): Record<string, any> {
    const result: Record<string, any> = {};
    Object.entries(TRAVELERS_TYPE).forEach((key) => {
      result[key[0]] = {
        ...firstOptBase,
        viajeros: this.addTravelers(formDataValue, key[1])
      };
    });
    return result;
  }

  /**
   * addTravelers
   * @param formDataValue formDataValue
   * @param typeT typeT
   * @returns returns
   */
  addTravelers(formDataValue: any, typeT?: any): Record<string, any> {
    const numberOfInsureds: any = formDataValue.numberOfInsured;

    let numberOfInsuredsOlder = 0;
    if (formDataValue.insuredOlderThan70years) {
      numberOfInsuredsOlder = formDataValue.insuredOlderThan70years.id;
    }

    let numberOfInsuredsRisk = 0;
    if (formDataValue.insuredsPlayRiskSports && formDataValue.insuredsPlayRiskSports.id) {
      numberOfInsuredsRisk = formDataValue.insuredsPlayRiskSports.id;
    }

    const args: {
      formDataValue: any;
      auxDestiny: number;
      auxExpatriado: boolean;
      auxDays: number;
      numViajerosNormales: number;
      numberOfInsuredsRisk: any;
      numberOfInsuredsOlder: any;
    } = this.setTravelersTypeArgs(formDataValue, typeT, numberOfInsureds, numberOfInsuredsOlder, numberOfInsuredsRisk);

    return this.setTravelersTypeValue(numberOfInsuredsOlder, numberOfInsuredsRisk, numberOfInsureds, args);
  }

  /**
   * setTravelersTypeArgs
   * @param formDataValue formDataValue
   * @param typeT typeT
   * @param numberOfInsureds numberOfInsureds
   * @param numberOfInsuredsOlder numberOfInsuredsOlder
   * @param numberOfInsuredsRisk numberOfInsuredsRisk
   * @returns returns
   */
  setTravelersTypeArgs(formDataValue: any, typeT: any, numberOfInsureds: any, numberOfInsuredsOlder: any, numberOfInsuredsRisk: any): {
    formDataValue: any;
    auxDestiny: number;
    auxExpatriado: boolean;
    auxDays: number;
    numViajerosNormales: number;
    numberOfInsuredsRisk: any;
    numberOfInsuredsOlder: any;
  } {
    const needGetValue: boolean = DURATION_INPUTS.some( value => {
      return formDataValue.insuranceDuration === value;
    });

    let insuranceDuration: any = formDataValue.insuranceDuration;
    if (needGetValue) {
      insuranceDuration = this.utilsSrv.getTranslate(formDataValue.insuranceDuration);
    }

    let isTypeTravel = false;
    if (typeT === '90') {
      isTypeTravel = true;
    }

    let isTypeAnual = false;
    if (typeT === 'anual') {
      isTypeAnual = true;
    }

    const isExpatriado: boolean = this.isExpatriado(isTypeAnual, insuranceDuration);
    const numViajerosNormales = numberOfInsureds.id - (numberOfInsuredsOlder + numberOfInsuredsRisk);
    const auxDays: number = this.insuranceTravelers(typeT, formDataValue);

    let auxExpatriado: boolean = isExpatriado;
    if (isTypeTravel) {
      auxExpatriado = true;
    }

    const auxDestiny: number =  formDataValue.countryDestinyEnvironment;

    return { formDataValue, auxDestiny, auxExpatriado, auxDays, numViajerosNormales,
      numberOfInsuredsRisk, numberOfInsuredsOlder };
  }

  /**
   * isExpatriado
   * @param isTypeAnual isTypeAnual
   * @param insuranceDuration insuranceDuration
   * @returns returns
   */
  isExpatriado(isTypeAnual: boolean, insuranceDuration: string): boolean {
    let isExpatriado: boolean;
    if (isTypeAnual) {
      isExpatriado = false;
    } else {
      isExpatriado = (insuranceDuration === 'Larga Estancia' || insuranceDuration === 'Larga estancia');
    }
    return isExpatriado;
  }

  /**
   * insuranceTravelers
   * @param typeT typeT
   * @param formDataValue formDataValue
   * @returns returns
   */
  insuranceTravelers(typeT: string, formDataValue: any): number {
    let auxDays: number = formDataValue.insuranceTime;
    if ((typeT === 'anual' || typeT === '90') && formDataValue.insuranceTime < Numbers.number365) {
      auxDays = Numbers.number365;
    }
    return auxDays;
  }

  /**
   * getCoverageType
   * @param type type
   * @returns returns
   */
  getCoverageType(type: any): string {
    return COVERAGE_TYPES[type] || '';
  }
}
